import Vue from 'vue'
import { Message, Cascader } from 'element-ui'
import xcUi from './xc-ui'

import App from './App.vue'
import router from './router'
import store from './store/index'
import http from './utils/http'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './scss/common.scss';

Vue.use(ElementUI);

// import './utils/rem' // 暂不使用
// import './libs/echarts' // 表单验证
// import './libs/vee-validate' // 表单验证
// import './libs/font-awesome' // 图标字体
// import './utils/date-format' // 日期格式
// import './utils/form-format' // 表单格式化
// import './utils/grace-checker' // 表单验证

Vue.use(xcUi);
Vue.use(Cascader);

Vue.prototype.$config = {
    ...process.env,
    adminPath: process.env.VUE_APP_ADMIN_PATH,
};
Vue.prototype.$http = http;
Vue.prototype.$message = Message;

Vue.config.productionTip = false

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
}).$mount('#app')
